import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class CallLiveText extends BaseOption {
  static label = "Live Text";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
  };
  static defaultValue = "Call in progress";
}
